import { OnboardingRouteNames } from "@/routes/onboarding"

export const ONBOARDING_FIRST_STEPS = [
    OnboardingRouteNames.MeterDetails,
    OnboardingRouteNames.MoveOut,
]

export const ONBOARDING_STEPPER_STEPS = [
    OnboardingRouteNames.Quote,
    OnboardingRouteNames.PersonalDetails,
    OnboardingRouteNames.PaymentDetails,
] as const

export const ONBOARDING_STEPPER_NOT_CLICKABLE_AT = [
    OnboardingRouteNames.PrePayment,
    OnboardingRouteNames.PrePaymentCdf,
    OnboardingRouteNames.PaymentDetails,
    OnboardingRouteNames.PaymentDetailsRetry,
    OnboardingRouteNames.OrderReview,
]

const ONBOARDING_PRE_QUOTE_STEPS = [
    OnboardingRouteNames.MoveOut,
    OnboardingRouteNames.MeterDetails,
    OnboardingRouteNames.MeterDetailsWithDetails,
    OnboardingRouteNames.MeterDetailsWithAffiliate,
    OnboardingRouteNames.MeterDetailsWithPartner,
    OnboardingRouteNames.MeterDetailsMonoEnergy,
    OnboardingRouteNames.ProviderCalendar,
    OnboardingRouteNames.EnergyLandscape,
    OnboardingRouteNames.MeterReadings,
] as const

const ONBOARDING_INELIGIBLE_STEPS = [
    OnboardingRouteNames.AddressIneligible,
    OnboardingRouteNames.MoveOutIneligible,
    OnboardingRouteNames.ElectricityMeterIneligible,
    OnboardingRouteNames.GasMeterIneligible,
] as const

export const ONBOARDING_STEPS_WITHOUT_STEPPER = [
    ...ONBOARDING_PRE_QUOTE_STEPS,
    ...ONBOARDING_INELIGIBLE_STEPS,
    // Post-quote pages without stepper
    OnboardingRouteNames.Confirmation,
    OnboardingRouteNames.PaymentDetailsErrorSignature,
    OnboardingRouteNames.PaymentDetailsUnpaidBills,
    OnboardingRouteNames.PaymentDetailsErrorPrepayment,
    OnboardingRouteNames.PaymentDetailsPendingPrepayment,
    OnboardingRouteNames.SecurityDeposit,
    OnboardingRouteNames.Onboarded,
] as const

// Steps before the user-details step where the logo should redirect back to the home page.
export const ONBOARDING_STEPS_WITH_HOME_REDIRECTION = [
    ...ONBOARDING_PRE_QUOTE_STEPS,
    ...ONBOARDING_INELIGIBLE_STEPS,
    OnboardingRouteNames.Quote,
] as const

export const ONBOARDING_STEPS_WITHOUT_BANNER = [
    OnboardingRouteNames.Onboarded,
    OnboardingRouteNames.Confirmation,
] as const
